import { agileData, teamDataType } from "../Types/Types";

export const data: agileData[] = [
  {
    img: "https://www.simform.com/static/s-d-product-eng.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#e6f9de",
  },
  {
    img: "https://www.simform.com/static/s-cloud-native-app-dev-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#e3fffd",
  },
  {
    img: "https://www.simform.com/static/s-devops-eng-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#fff4ed",
  },
  {
    img: "https://www.simform.com/static/s-bI-data-eng-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#fff4dc",
  },
  {
    img: "https://www.simform.com/static/s-performance-testing-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#fff4ed",
  },
  {
    img: "https://www.simform.com/static/s-digital-exp-design-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#eef9f8",
  },
  {
    img: "https://www.simform.com/static/cto-as-a-service-icon.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#ddf0ff",
  },
  {
    img: "https://www.simform.com/static/ApplicationDevelopmentServices.svg",
    title: "Digital Product Engineering",
    description:
      "Solve your unique business problems by building impactful software products",
    bgcolor: "#fffde6",
  },
];

export const teamData: teamDataType[] = [
  {
    img: "https://www.simform.com/static/2080620/ce9c4/jansen.webp",
    name: "Jansen Myburgh",
    designation: "Founder, Roundr",
    logo: "https://www.simform.com/static/freewire-logo.png",
  },
  {
    img: "https://www.simform.com/static/0f06150/ce9c4/jawann.webp",
    name: "Jawann Swislow",
    designation: "CIO, FreeWire",
    logo: "https://www.simform.com/static/roundr-header-logo.png",
  },
  {
    img: "https://www.simform.com/static/72ee54b/ce9c4/olivia.webp",
    name: "Olivia Butters",
    designation: "Programme Manager, Madzi Alipo",
    logo: "https://www.simform.com/static/madzi-alipo-logo.png",
  },
  {
    img: "https://www.simform.com/static/cc4a399/ce9c4/danielle.webp",
    name: "Danielle Beben",
    designation: "CEO, Emrana Engineering",
    logo: "https://www.simform.com/static/emrana-engineering-logo.png",
  },
  {
    img: "https://www.simform.com/static/9247e9d/ce9c4/justin.webp",
    name: "Justin Wollman",
    designation: "Product Manager, SwiftShopper",
    logo: "https://www.simform.com/static/swift-shopper-logo.png",
  },
  {
    img: "https://www.simform.com/static/cfc8a81/ce9c4/ritwik.webp",
    name: "Ritwik Pavan",
    designation: "CEO, Linker Logic",
    logo: "https://www.simform.com/static/linker-logic-logo.png",
  },
  {
    img: "https://www.simform.com/static/c7dac80/ce9c4/Jeff.webp",
    name: "Jeff Petreman",
    designation: "CEO, Trans Action Logistics",
    logo: "https://www.simform.com/static/trans-action-logistics-logo.png",
  },
  {
    img: "https://www.simform.com/static/af9983e/cda49/andy.webp",
    name: "Andy Gibson",
    designation: "CIO, Mission Rabies",
    logo: "https://www.simform.com/static/mission-rabbies-logo.png",
  },
  {
    img: "https://www.simform.com/static/9247e9d/ce9c4/justin.webp",
    name: "Justin Wollman",
    designation: "Product Manager, SwiftShopper",
    logo: "https://www.simform.com/static/swift-shopper-logo.png",
  },
  {
    img: "https://www.simform.com/static/cfc8a81/ce9c4/ritwik.webp",
    name: "Ritwik Pavan",
    designation: "CEO, Linker Logic",
    logo: "https://www.simform.com/static/linker-logic-logo.png",
  },
  {
    img: "https://www.simform.com/static/c7dac80/ce9c4/Jeff.webp",
    name: "Jeff Petreman",
    designation: "CEO, Trans Action Logistics",
    logo: "https://www.simform.com/static/trans-action-logistics-logo.png",
  },
  {
    img: "https://www.simform.com/static/af9983e/cda49/andy.webp",
    name: "Andy Gibson",
    designation: "CIO, Mission Rabies",
    logo: "https://www.simform.com/static/mission-rabbies-logo.png",
  },
];
